import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import { useFormikContext } from "formik";

export default function ListBoxWidget(props) {
  const { firstList, secondList, showAlias, name } = props;
  const { setFieldValue, values } = useFormikContext();

  const [firstListValues, setFirstListValues] = useState(firstList);
  const [secondListValues, setSecondListValues] = useState(secondList);
  const [selectedListValues, setSelectedListValues] = useState([]);

  useEffect(() => {
    if (secondListValues?.length > 0) {
      const optionsList = firstListValues.filter(
        (x) => !secondListValues.some((y) => x.value === y.value)
      );
      setFirstListValues(optionsList);
    }
  }, []);

  const moveAllRight = () => {
    setFirstListValues([]);
    setSecondListValues([...secondListValues, ...firstListValues]);
  };
  const moveAllLeft = () => {
    setSecondListValues([]);
    setFirstListValues([...firstListValues, ...secondListValues]);
  };
  const moveLeft = () => {
    if (selectedListValues !== null) {
      let optionsList = secondListValues.filter(
        (x) => !selectedListValues.some((y) => x.value === y.value)
      );
      setSecondListValues(optionsList);
      setFirstListValues([...firstListValues, ...selectedListValues]);
      setSelectedListValues(null);
      setFieldValue([name], optionsList);
    }
  };
  const moveRight = () => {
    if (selectedListValues !== null) {
      let rightList = firstListValues.filter(
        (x) => !selectedListValues.some((y) => x.value === y.value)
      );
      setFirstListValues(rightList);
      setSecondListValues([...secondListValues, ...selectedListValues]);
      setSelectedListValues(null);
      setFieldValue([name], [...secondListValues, ...selectedListValues]);
    }
  };

  const handleChange = (e) => {
    const temp = Array.from(e.target.selectedOptions);
    const data = temp.map((x) => {
      return { label: x.id, value: x.value, [name]: x.label };
    });
    setSelectedListValues(data);
  };

  function EnhancedTableToolbar(props) {
    const { label } = props;
    return (
      <>
        <u>
          <b>{label}:</b>
        </u>
      </>
    );
  }
  return (
    <div className="tableformik">
      <EnhancedTableToolbar {...props} />
      <div>
        <select
          multiple="multiple"
          size="6"
          id="First"
          onChange={(e) => {
            handleChange(e);
          }}
          className="listbox-width-font"
        >
          {firstListValues?.map((item, i) => (
            <option
              value={item.value}
              key={item.value}
              id={item.label}
              label={
                showAlias === "Y"
                  ? "[" + item.value + "] " + item.label
                  : item.label
              }
            />
          ))}
        </select>
      </div>

      <div>
        <div>
          <Button
            variant="contained"
            onClick={() => moveRight()}
            className="clearbtn"
          >
            Add
          </Button>
          <Button
            variant="contained"
            onClick={() => moveLeft()}
            className="clearbtn"
          >
            Remove
          </Button>
        </div>
      </div>

      <div>
        <select
          size="6"
          onChange={(e) => {
            handleChange(e);
          }}
          multiple
          className="listbox-width-font"
          id="Second"
        >
          {secondListValues.map((item, i) => (
            <option
              value={item.value}
              key={item.value}
              id={item.label}
              label={
                showAlias === "Y"
                  ? "[" + item.value + "] " + item.label
                  : item.label
              }
            />
          ))}
        </select>
      </div>
    </div>
  );
}
